import React, { useEffect, useState } from 'react';
import { getDiscordConfig } from '../config/discord';
import { getBackendConfig } from '../utils/backendConfig';

export const ConfigTest: React.FC = () => {
  const [discordConfig, setDiscordConfig] = useState<any>(null);
  const [backendConfig, setBackendConfig] = useState<any>(null);

  useEffect(() => {
    const loadConfigs = async () => {
      try {
        console.log('=== CONFIG TEST ===');
        
        // Test backend config loading
        const backend = await getBackendConfig();
        console.log('Backend config loaded:', backend);
        setBackendConfig(backend);
        
        // Test Discord config loading
        const discord = await getDiscordConfig();
        console.log('Discord config loaded:', discord);
        setDiscordConfig(discord);
        
      } catch (error) {
        console.error('Config loading error:', error);
      }
    };
    
    loadConfigs();
  }, []);

  return (
    <div style={{ padding: '20px', border: '1px solid #ccc', margin: '10px', backgroundColor: '#f0f0f0' }}>
      <h3>🧪 Config Test Component</h3>
      <div>
        <h4>Backend Config:</h4>
        <pre>{JSON.stringify(backendConfig, null, 2)}</pre>
      </div>
      <div>
        <h4>Discord Config:</h4>
        <pre>{JSON.stringify(discordConfig, null, 2)}</pre>
      </div>
    </div>
  );
};

export default ConfigTest;